import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
  CreateDepartmentInput,
  UpdateDepartmentInput,
} from './department.interface';

const API_URI = `${environment.apiBaseUrl}/departments`;

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  http: HttpClient = inject(HttpClient);

  getDepartments() {
    return this.http.get(API_URI);
  }

  create(input: CreateDepartmentInput) {
    return this.http.post(API_URI, input);
  }

  update(input: UpdateDepartmentInput) {
    return this.http.put(API_URI, input);
  }
  delete(id: string) {
    return this.http.delete(API_URI + `/single/${id}`);
  }
}
